module.exports = __webpack_public_path__ + "static/img/kids_2.3ceba414.png";